
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import FormItem from 'element-ui/lib/form-item';

var script = {
  name: 'PendoFormItem',
  components: {
    ElFormItem: FormItem
  },
  props: {
    label: {
      type: String,
      default: null
    },
    prop: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: null
    }
  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('el-form-item', {
    staticClass: "pendo-form-item",
    attrs: {
      "show-message": true,
      "rules": _vm.rules,
      "label": _vm.label,
      "prop": _vm.prop
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-form-item.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoFormItem = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoFormItem;
